import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import CopilotWidget from './CopilotWidget';

// Routen, auf denen der Copilot NICHT erscheinen soll
const HIDDEN_PATHS = ['/login', '/register', '/setup-password', '/mitarbeiter-login', '/mitarbeiter-setup', '/danke'];

/**
 * Rendert das Copilot-Widget nur fuer eingeloggte Nutzer und blendet
 * ihn auf reinen Marketing-/Auth-Routen aus.
 */
export const CopilotMount = () => {
  const location = useLocation();
  const { isAuthenticated, company } = useAuth();

  // Auch Mitarbeiter zaehlen als "eingeloggt" — pruefen via localStorage
  const employeeToken = typeof window !== 'undefined' ? localStorage.getItem('mitarbeiterToken') : null;
  const employeeAuthed = Boolean(employeeToken);

  if (!isAuthenticated && !employeeAuthed) return null;
  const path = location.pathname || '';
  if (HIDDEN_PATHS.some((p) => path.startsWith(p))) return null;

  const name =
    (company && (company.name || company.companyName)) ||
    (typeof window !== 'undefined' ? localStorage.getItem('mitarbeiterName') : null) ||
    null;
  const firstName = name ? String(name).split(' ')[0] : null;

  return <CopilotWidget userDisplayName={firstName} />;
};

export default CopilotMount;
